import React, { useCallback } from 'react';
import SearchBox from '../../../../../../components/outline/SearchBox';
import BaseForm from '../../../../../../components/form/BaseForm';
import Input from '../../../../../../components/input/Input/Input';
import { _LIST_PAGINATION_MODEL } from '../../../../../../store/modules/app/models';
import {
  SUB_PAGE_LIST_SEARCH_DATA_MODEL,
  SUB_PAGE_LIST_SEARCH_OPTION_MODEL,
} from '../../../../../../store/modules/widget/models';
import './HomeSubListSearchBox.scss';

const HomeSubListSearchBox = (props) => {
  const { setData, searchData, getList } = props;
  const { title, memo } = searchData;

  const getSubPageList = useCallback(() => {
    getList({
      searchOption: searchData,
      pagination: _LIST_PAGINATION_MODEL,
    });
  }, [searchData, getList]);

  return (
    <SearchBox
      className="home-sub-list-search-box"
      onSearch={getSubPageList}
      onClear={() => {
        getList({
          searchOption: SUB_PAGE_LIST_SEARCH_OPTION_MODEL,
          pagination: _LIST_PAGINATION_MODEL,
          isInit: true,
        });
        setData({
          path: [],
          value: SUB_PAGE_LIST_SEARCH_DATA_MODEL,
        });
      }}
    >
      {/*서브 페이지 제목 검색*/}
      <BaseForm
        label={'서브 페이지 제목'}
        content={
          <Input
            value={title}
            onChange={(value) =>
              setData({
                path: ['title'],
                value,
              })
            }
            maxLength={30}
            size="large"
            onPressEnter={getSubPageList}
          />
        }
      />

      {/*서브 페이지 메모 검색*/}
      <BaseForm
        label={'서브 페이지 메모'}
        content={
          <Input
            value={memo}
            onChange={(value) =>
              setData({
                path: ['memo'],
                value,
              })
            }
            maxLength={30}
            size="large"
            onPressEnter={getSubPageList}
          />
        }
      />
    </SearchBox>
  );
};

export default HomeSubListSearchBox;
